import styles from "./IntegratedCTA.module.scss";
import {
  SecondaryButton,
  UnderlinedButton,
} from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { SaleTagFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SaleTagFilled";
import { useTradeInContext } from "../../TradeInContext";
import { dispatchCustomEvent } from "../../../../utils/customEvent/dispatchCustomEvent";
import { TradeInEvents } from "../../TradeIn";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  isFullWidthMode: boolean;
  isTradeInModelLoading: boolean;
  onClick: () => void;
};

export const IntegratedCTAUI = ({
  isFullWidthMode,
  isTradeInModelLoading,
  onClick,
}: Props) => {
  const { promotionValue, hasPromoCode } = useTradeInContext();
  const dispatchTradeInReadMoreEvent = () => {
    dispatchCustomEvent(TradeInEvents.TRADE_IN_READ_MORE_EVENT);
  };

  return (
    <div
      className={cx(styles.cta, { fullWidthMode: isFullWidthMode })}
      data-testid="integrated-cta"
    >
      <h2 className={styles.cta__title}>
        Got a device you are no longer using?
      </h2>
      <p className={styles.cta__description}>
        Trade-in now and get some money back when making your new purchase
      </p>
      <SecondaryButton onClick={onClick} submitting={isTradeInModelLoading}>
        Trade in device
      </SecondaryButton>
      {!!promotionValue && (
        <div className={styles.cta__promo}>
          <p className={styles.cta__promoMessage}>
            <SaleTagFilled size="medium" className={styles.saleTag} />
            {hasPromoCode ? (
              <span>Receive an extra {promotionValue} off with promo code</span>
            ) : (
              <span>Get an extra {promotionValue} when you trade-in</span>
            )}
          </p>
          <UnderlinedButton
            tag="a"
            role="button"
            onClick={() => {
              dispatchTradeInReadMoreEvent();
            }}
          >
            Read more
          </UnderlinedButton>
        </div>
      )}
    </div>
  );
};
